import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../store';

export const options = (state: RootState) => state.options;

export const buildOptions = createSelector(options, state => state.options.build);

export const allOptions = createSelector(options, state => state.options.all);

export const productOptions = createSelector(options, state => state.options.product);

export const pendingBuildOptions = createSelector(options, state => state.pending.build);

export const pendingProductOptions = createSelector(options, state => state.pending.product);

export const pendingInitialisation = createSelector(options, state => state.pendingInitialisation);
